import { client } from '../../interfaces'

interface clientListProps {
  clients: client[]
  setShowDeleteClientModal: React.Dispatch<React.SetStateAction<boolean>>
  setSingleClient: React.Dispatch<React.SetStateAction<null | client>>
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>
}

const ClientList = ({
  clients,
  setShowDeleteClientModal,
  setSingleClient,
  setShowEditModal
}: clientListProps) => {
  return (
    <table className='table-fixed w-2/3 mx-auto mt-20 text-2xl'>
      <tbody>
        {clients.map((client: client) => {
          return (
            <tr key={client.id}>
              <td className='border-2 text-center'>
                {client.name} {client.phone}
                <button
                  className='float-right ml-10 mr-8 text-red-400'
                  onClick={() => {
                    setSingleClient(client)
                    setShowDeleteClientModal(true)
                  }}>
                  X
                </button>
                <button
                  className='float-right text-gray-500'
                  onClick={() => {
                    setSingleClient(client)
                    setShowEditModal(true)
                  }}>
                  Editar
                </button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default ClientList
